import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CategoryMiniCard from "../components-maincampus/components/CategoryMiniCard";
import { getCategoriesThemes } from "../../../../redux/api/courses"; 
import { useHistory } from "react-router-dom";

const ThemeAxisSection = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const companyId = 0;

  const handleRedirect = (categoryId) => {
    history.push(`/mi-empresa/${companyId}?thematic=${categoryId}`);
  };

    useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await getCategoriesThemes();
        setCategories(res || []);
      } catch (error) {
        console.error("Error fetching categories", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);


  return (
    <Wrapper>
      <Header>
        <Title>¿Qué te gustaría aprender?</Title>
      </Header>

      <Grid>
        {loading ? (
          <p>Cargando categorías...</p>
        ) : (
          categories.map((category) => (
            <CategoryMiniCard
              key={category.id}
              title={category.name}
              badge={category.badge}
              image={category.imagen}
              onClick={() => handleRedirect(category.id)}
            />
          ))
        )}
      </Grid>
    </Wrapper>
  );
};

export default ThemeAxisSection;

const Wrapper = styled.div`
  width: 100%;
  background: #fff;
  border-radius: 24px;
  padding: 24px;
`;

const Header = styled.div`
  margin-bottom: 20px;
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #222;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
`;